import * as Actions from '../../actions/inspection/type';

export const AddInspectionReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.ADD_INSPECTION_REQUEST:
      return { loading: true };
    case Actions.ADD_INSPECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        newInspection: action.payload,
        success: true,
      };
    case Actions.ADD_INSPECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_ADD_INSPECTION_STATES:
      return {
        ...state,
        loading: false,
        error: '',
        newInspection: '',
        success: false,
      };
    default:
      return state;
  }
};

export const GetInspectionReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_INSPECTION_REQUEST:
      return { loading: true };
    case Actions.GET_INSPECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        inspection: action.payload,
      };
    case Actions.GET_INSPECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_ADD_INSPECTION_STATES:
      return {
        ...state,
        loading: false,
        error: '',
        inspection: null,
      };
    default:
      return state;
  }
};

export const deleteInspectionReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.DELETE_INSPECTION_REQUEST:
      return { loading: true };
    case Actions.DELETE_INSPECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteInspection: action.payload || '',
      };
    case Actions.DELETE_INSPECTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_DELETE_INSPECTION_STATES:
      return {
        ...state,
        loading: false,
        deleteInspection: null,
        error: null,
      };
    default:
      return state;
  }
};

export const getErrorCodeDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_ERROR_CODE_DETAILS_REQUEST:
      return { loading: true };
    case Actions.GET_ERROR_CODE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        codeDetails: action.payload || '',
      };
    case Actions.GET_ERROR_CODE_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_GET_ERROR_CODE_DETAILS:
      return {
        ...state,
        loading: false,
        codeDetails: null,
        error: null,
        success: false,
      };
    default:
      return state;
  }
};
